import React, { useContext, useEffect, useState } from "react";
import { message } from "antd";
import { errorMessage, QuestionType } from "../../../../../service/service";
import PaperContext from "../../context";
import {
    checkTopic,
    setPaperTopic,
    TopicType
} from "../../../../../service/homework";
import usePromiseCallback from "../../../../../utils/usePromiseCallback";
import { EditBlockPure } from "../../../../exam/addExam/components/EditBlock";

export interface EditBlockOption {
    hasDelete?: boolean;
    hasAdd?: boolean;
    hasSave?: boolean;
    hasScore?: boolean;
    customCheckTopic?: (topic: TopicType) => {
        result: "success" | "error";
        msg?: string;
    };
    onDelete?: () => void;
}

interface EditBlockProps {
    type: QuestionType;
    children: React.ReactNode;
    topic: TopicType;
    hasDelete?: EditBlockOption["hasDelete"];
    hasAdd?: EditBlockOption["hasAdd"];
    hasSave?: EditBlockOption["hasSave"];
    hasScore?: EditBlockOption["hasScore"];
    autoScore?: number;
    disableScore?: boolean;
    customCheckTopic?: EditBlockOption["customCheckTopic"];
    onDelete?: EditBlockOption["onDelete"];
    onChange: (topic: TopicType) => void;
}

export function EditBlock({
    type,
    children,
    topic,
    hasDelete = false,
    hasAdd = true,
    hasSave = true,
    hasScore = true,
    autoScore,
    disableScore = false,
    customCheckTopic,
    onDelete,
    onChange
}: EditBlockProps) {
    const [trunk, setTrunk] = useState(topic.trunk);
    const [score, setScore] = useState(topic.score || 0);
    const { paperId, paperParams, addTopic, lockEdit, loadPaperData } =
        useContext(PaperContext);
    const [inputTrunk, setInputTrunk] = useState(true);

    useEffect(() => {
        setInputTrunk(!/<[^>]+>/g.test(trunk));
    }, [trunk]);

    useEffect(() => {
        (autoScore === 0 || autoScore) && setScore(autoScore);
    }, [autoScore]);

    const onSave = usePromiseCallback(() => {
        const scoreInt = score || 0; // 有可能是NaN

        const { result, msg } = customCheckTopic
            ? customCheckTopic({ ...topic, trunk, score: scoreInt })
            : checkTopic({ ...topic, trunk, score: scoreInt });

        if (result === "error") {
            return message.error(msg).promise;
        }

        return (
            setPaperTopic(paperParams, paperId, topic.topicId, trunk, type, {
                ...topic,
                score: scoreInt
            })
                // .then((topicId) => onChange({...topic, topicId, tempTopicId: topicId, trunk, score: scoreInt}))
                .then(() => loadPaperData && loadPaperData())
                .then(() => {
                    message.info("保存成功!");
                })
                .catch(e => message.error(errorMessage(e)))
        );
    });

    const onScoreChange = (score: number) => {
        onChange({ ...topic, score });
        setScore(score);
    };

    return (
        <EditBlockPure
            inputTrunk={inputTrunk}
            trunk={trunk}
            onChange={onChange}
            type={type}
            topic={topic}
            setTrunk={setTrunk}
            children={children}
            hasSave={hasSave}
            hasDelete={hasDelete}
            onDelete={onDelete}
            setInputTrunk={setInputTrunk}
            disableScore={disableScore}
            lockEdit={lockEdit}
            addTopic={addTopic}
            onSave={onSave}
            score={score}
            onScoreChange={onScoreChange}
            hasAdd={hasAdd}
        />
    );
}
